<!-- 常胜榜单 -->
<template>
<div class="football-rank-list">
    <div class="rank-title">
        <div class="main">常胜榜<img :src="require('../assets/ps.png')" alt="" @click="rulesStatus = true"></div>
        <div class="subf">按照盈利场数排行</div>
        <div class="win-cup"><img :src="require('../assets/rank-cup.png')" alt=""></div>
    </div>
    <div class="list-container">
        <ul class="list" v-if="pageLoading">
            <li class="no-data" v-if="list.length == 0">
                <img :src="require('../assets/no-rank.png')" alt="" height="125">
                <div class="txt">暂时还没有记录</div>
                <div class="txt">快去参加吧</div>
            </li>
            <li v-for="(item,index) in list.slice(0,3)" :key="index">
                <div class="user-avatar">
                    <div class="tag first" v-if="index == 0"><img :src="require('../assets/top1.png')" alt=""></div>
                    <div class="tag" v-if="index == 1"><img :src="require('../assets/top2.png')" alt=""></div>
                    <div class="tag" v-if="index == 2"><img :src="require('../assets/top3.png')" alt=""></div>
                    <img :src="item.avatar" alt="">
                </div>
                <div class="flex-cont">
                    <div class="user-name">{{item.username}}</div>
                    <div class="join-total">下注{{item.totalCount}}次</div>
                </div>
                <div class="lose">胜{{item.winCount}}场 <img :src="require('../assets/football.png')" alt=""></div>
            </li>
        </ul>
        <div class="look-more" @click="oftenStatus = true" >查看全部</div>
    </div>
    <OftenWinRank :status.sync="oftenStatus" :listArray="list" />
    <OftenRules :status.sync="rulesStatus" />
</div>
</template>
<script>
import OftenWinRank from '../dialog/often-win-rank.vue'
import OftenRules from '../dialog/often-rules.vue'
export default {
    name:'OftenWin',
    components:{OftenWinRank,OftenRules},
    data(){
        return {
            list:[],
            oftenStatus:false,
            pageLoading:false,
            rulesStatus:false
        }
    },
    created(){
        this.getList();
    },
    methods:{
        async getList(){
            let result = await this.$axios.post('/worldcup2022/game/coin/ever/victorious/generals/list',{limit:10})
            this.pageLoading = true;
            if( result.code == 0){
                console.log('常胜榜,-------->',result)
                this.list = result.data.users;
            }
        }
    }

}
</script>
<style lang="less" scoped>
.football-rank-list{
    background:linear-gradient(308deg,#fff0d3 23%, #fff7ea 76%);
    border: 1px solid #ffe5c5;
    border-radius: 10px;
    padding:10px; position: relative;
    .rank-title{
        padding:22px 0 18px; position: relative;
        .main{font-size: 20px; line-height: 28px; color: #111; margin-bottom: 1px; font-weight: 500;
            display: flex; align-items: center;
            img{margin-left: 5px; height: 14px; cursor: pointer;}
        }
        .subf{
            font-size: 12px; line-height: 17px; color: #111; opacity: 0.8;
        }
        .win-cup{position: absolute; right: 25px; bottom: 0;}
    }
    .list-container{
        padding:20px 10px 0; background: #fff; border-radius: 10px; overflow: hidden;
        .list{
            li{
                display: flex; align-items: center; margin-bottom: 10px; padding-bottom: 10px;
                .user-avatar{
                    position: relative; margin-right: 5px;
                    .tag{position: absolute; height:20px; left: -6px; top: -10px;
                        &:first{height: 22px; top: -12px;}
                    }
                    &>img{width: 50px; height: 50px; border-radius: 50%; display: block; object-fit: cover; border: 1px solid #ffb500;}
                }
                .flex-cont{
                    flex:1; overflow: hidden;
                    .user-name{
                        overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 14px;
                    }
                    .join-total{font-size: 12px; color: #999; margin-top: 10px;}
                }
                .lose{
                    display: flex; align-items: center;
                    font-size: 12px; line-height: 18px;background: radial-gradient(#f44342, #ff8a7d);border-radius: 13px;
                    color: #fff; padding: 4px 5px 4px 10px;
                    img{height: 12px; margin-left: 5px;}
                }
                &.no-data{
                    font-size: 14px; line-height: 20px; color: #aaa; padding: 30px 0; text-align: center; display: block;
                    img{display: block; margin: 0 auto 20px}
                }
            }
        }
        .look-more{
            user-select: none; cursor: pointer; margin-bottom: 20px; 
            background: #f8f8f8;border-radius: 4px; font-size: 14px; line-height: 36px; color: #727272; text-align: center;
            &:hover{background-color: #eee;}
        }
    }
}
</style>